"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[7464],{

/***/ 7464:
/***/ ((module) => {

module.exports = JSON.parse('{"firmSettingsSaved":"The firm details have been saved","somethingWentWrong":"Something went wrong!","pleaseTryAgainOrContactSupport":"Please try again. If the problem persists, contact support.","resetFirmSettingMessage":"The texts have now been restored.","sustainabilityReportingActivated":"The sustainability report has been activated for the firm","assignmentAgreementInfoSaved":"The information for the engagement agreement has been saved"}');

/***/ })

}]);